module.exports = __webpack_public_path__ + "static/media/outreachhead.910f16fe.jpg";